import {BaseContainerModel} from '../../base-container.model';
import {bl_wf_issue_event_RowClass} from '../../../dbschema/bl_wf_issue_event.model';

export class WfIssueEventContainerModel extends BaseContainerModel {
  issueEvent: bl_wf_issue_event_RowClass = new bl_wf_issue_event_RowClass();
}
